import { render, staticRenderFns } from "./_UserBar.vue?vue&type=template&id=4fcf709e&"
import script from "./_UserBar.vue?vue&type=script&lang=ts&"
export * from "./_UserBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fcf709e')) {
      api.createRecord('4fcf709e', component.options)
    } else {
      api.reload('4fcf709e', component.options)
    }
    module.hot.accept("./_UserBar.vue?vue&type=template&id=4fcf709e&", function () {
      api.rerender('4fcf709e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/navbar/_UserBar.vue"
export default component.exports